export const LogOut = () => {
  localStorage.setItem("accessToken", "");
  localStorage.setItem("refreshToken", "");
  localStorage.setItem("userData", "");
  localStorage.setItem("persist:root", "");
  window.location.href = "/login";
};
